<canvas #icon class="icon" [width]="size" [height]="size"></canvas>
